//#region Styles
import {
    ContainerParts 
} from "components/styles";
//#endregion
//#region Components
import Part1 from "./components/Part1/Part1";
import Part2 from "./components/Part2/Part2";
//#endregion

const Step1 = ({
    form,
    errors
}) => {
    const changeFieldFileData = value => {
        form.change("fileData", value, false);
    }
    return (
        <ContainerParts>
            <Part1/>
            <Part2 
                fileData={form.value.fileData}
                changeForm={changeFieldFileData}
                errors={errors}/>
        </ContainerParts>
    );
}

export default Step1;